// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2r_sU","content":"LayoutSettings_content__3PcJw"};